import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import expenseSlice from './slices/expenseSlice';
import sessionSlice from './slices/sessionSlice';
import reportSlice from './slices/reportSlice';
import uiSlice from './slices/uiSlice';
import subscriptionSlice from './slices/subscriptionSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    expenses: expenseSlice,
    sessions: sessionSlice,
    reports: reportSlice,
    ui: uiSlice,
    subscription: subscriptionSlice,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        // Only ignore Firestore Timestamp objects and Date objects in specific paths
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
        ignoredActionPaths: [
          'payload.uploadedAt',
          'payload.createdAt',
          'payload.updatedAt',
          'payload.date', // Allow Date objects in expense payloads
          'meta.arg.originalPromise',
        ],
        ignoredPaths: [
          'auth.user.createdAt',
          'auth.user.updatedAt',
          'expenses.expenses.uploadedAt',
          'expenses.expenses.date', // Allow Date objects in expenses array
          'sessions.sessions.startTime',
          'sessions.sessions.endTime',
          'reports.reports.createdAt',
        ],
        // Custom check to allow Date objects everywhere
        isSerializable: (value: any) => {
          // Allow Date objects - they're safely serializable
          if (value instanceof Date) {
            return true;
          }
          // Allow Firestore Timestamps (handled by ignoredPaths)
          return true;
        },
        // Warn about non-serializable values to catch issues early
        warnAfter: 32,
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
